(function (doc, win) {

      var docEl = doc.documentElement,
    
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    
        recalc = function () {
    
    var clientWidth = docEl.clientWidth;
    console.log("clientwidth is ", clientWidth);
    
    if (!clientWidth) return;
    
    docEl.style.fontSize = 38 * (clientWidth / 750) + 'px';
    
    console.log(docEl.style.fontSize)
    
        };
    
    if (!doc.addEventListener) return;
    
    win.addEventListener(resizeEvt, recalc, false);
    
    doc.addEventListener('DOMContentLoaded', recalc, false);
    
    })(document, window);


// WEBPACK FOOTER //
// ./src/rem.js